// Same cap as services\live_matches\LiveMatchList::LIMIT.
export const LIVE_MATCHES_LIMIT = 50;

/**
 * The live match list after one live_matches socket message
 * (services\live_matches\LiveMatchPush): a snapshot replaces the list, and an
 * upsert/remove pair changes single matches. An upserted match just changed,
 * so it moves to the top, matching the server's most-recently-active order.
 */
export function applyLiveMatchesMessage(matches, message) {
	if(!message) {
		return matches;
	}
	if(Array.isArray(message.snapshot)) {
		return message.snapshot.slice(0, LIVE_MATCHES_LIMIT);
	}
	const upsert = message.upsert || [];
	const remove = message.remove || [];
	if(upsert.length === 0 && remove.length === 0) {
		return matches;
	}
	const changedIds = new Set([...remove, ...upsert.map((match) => match.match_id)]);
	const kept = matches.filter((match) => !changedIds.has(match.match_id));
	return [...upsert, ...kept].slice(0, LIVE_MATCHES_LIMIT);
}
